import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, } from "react-redux";
import { clearAuthComptable, } from "../Redux/authComptableSlice";
import { TiHome } from "react-icons/ti";
import { IoPerson } from "react-icons/io5";
import { BsFileText, BsCardChecklist } from "react-icons/bs";
import { AiOutlineLogout } from "react-icons/ai";

const SidebarCompta = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 840);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  //const auth = useSelector(selectAuthComptable);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 840);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (path) => {
    navigate(path);
    if (isMobile) document.body.classList.remove("overflow-hidden");
  };

  const handleLogout = () => {
    dispatch(clearAuthComptable());
    navigate("/");
  };

  const menuItems = [
    { label: "Dashboard", icon: TiHome, path: "/EspaceCompta" },
    { label: "Clients", icon: IoPerson, path: "/EspaceCompta/clients" },
    { label: "Devis", icon: BsFileText, path: "/EspaceCompta/devis" },
    { label: "Factures", icon: BsCardChecklist, path: "/EspaceCompta/factures" },
  ];

  const isActiveMain = (item) => location.pathname === item.path;

  return (
    <div className="relative">
      {!isMobile && (
        <div className="fixed top-0 left-0 flex flex-col h-screen bg-color1 text-color2 px-0 py-6 overflow-hidden scrollbar-thin scrollbar-thumb-black scrollbar-track-gray-900 rounded-r-lg border-r-2 border-color1/30">

          {/* Logo */}
          <div className="flex flex-col items-center cursor-pointer justify-center mb-6">
            <img
              src={require('../assets/logo.png')}
              alt="Logo Gestion Freelance"
              className="h-[50px] w-[137.25px] object-contain"
            />
          </div>

          {/* Menu principal */}
          <div className="flex-1 flex flex-col gap-2 overflow-y-auto">
            {menuItems.map(item => {
              const selected = isActiveMain(item);
              return (
                <button
                  key={item.label}
                  onClick={() => handleClick(item.path)}
                  className={`flex flex-row items-center gap-4 px-5 py-2 w-full font-bold text-base font-Poppins
                    ${selected ? "border-l-4 border-color3 text-color3 rounded-l-md" : "border-l-0 text-color2"}`}
                >
                  <item.icon size={20} className={selected ? "text-color3" : "text-color2"} />
                  <p>{item.label}</p>
                </button>
              );
            })}
          </div>

          {/* Logout */}
          <div className="flex flex-col gap-2 mt-4">
            <button
              onClick={handleLogout}
              className="flex flex-row items-center gap-4 px-5 py-2 w-full font-bold text-base font-Poppins border-l-0 text-color2 rounded-l-md"
            >
              <AiOutlineLogout size={20} />
              <p>Se déconnecter</p>
            </button>
          </div>

        </div>
      )}
    </div>
  );
};

export default SidebarCompta;
